import {
  Button,
  Checkbox,
  Chip,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  TextField
} from "@material-ui/core";
import Gridm from '@mui/material/Grid';
import { Typography, Stack, FormControl, Divider, InputLabel, SelectChangeEvent } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { VendorBlockData } from "../../../reducers/vendor/VendorBlockDataReducer";
import React, { Fragment, useEffect, useState } from "react";
import useStyles from "./VendorBlocking.css";
import translation from "../../../i18n/i18.json";
import { BlockingType } from "../../../models/BlockingType";
import { CompanyCodes } from "../../../models/CompanyCodes";
import { BlockingNature } from "../../../models/BlockingNature";
import { BlockingReason } from "../../../models/BlockingReason";
import { FormError } from "../../../models/FormValidation/FormError";
import AllActions from "../../../actions";
import { useDispatch, useSelector } from "react-redux";
import { VendorBlockingService } from "../../../services/VendorBlockingService";
import { VendorBlockMeta } from "../../../models/VendorBlocking/VendorBlockMeta";
import {
  DropdownOptions_VendorBlocing_Reason,
  DropdownOptions_VendorBlocking_Type,
  FileUploadTypes,
  InforDisplyaDuration,
  NavigationPaths,
  FieldsLengthConstants,
  App_Roles,
  VendorCategoryData,
  SpendManagedByData
} from "../../../constants/AppConstants";
import FileUpload from "../../../components/FileUpload/FileUpload";
import { UserFile } from "../../../models/UserFile";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { BlockVendorCompany, VendorBlockingData } from "../../../models/VendorBlocking/VendorBlockingData";
import { useHistory } from "react-router-dom";
import { Company } from "../../../models/Company";
import { Po } from "../../../models/Po";
import CancelIcon from "@material-ui/icons/Cancel";
import { PaymemntBlock } from "../../../models/VendorBlocking/PaymemntBlock";
import { VendorMasterData } from "../../../services/VendorMasterData";
import VendorDetail from "../VendorDetail/VendorDetail";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { Department } from "../../../models/Department";
import { User } from "../../../models/Master/User";
import { MasterDataService } from "../../../services/MasterDataService";
import { UserCompany } from "../../../models/UserCompany";
import {RequestTypes} from "../../../constants/AppConstants";
import { RootState } from "../../../reducers";
import { SAPVendor } from "../../../models/SAPVendor";
import { VendorCreateState } from "../../../reducers/vendor/VendorCreateReducer";
import { RMCategory } from "../../../models/RMCategory";
import { ProcurementCategorySummary, ProcurementSubcategorySummary } from "../../../models/Master/ProcurementCategorySummary";
import { MasterMetaDataService } from "../../../services/MasterMetaDataService";
import { Util } from "../../../utils/Util";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";
import { Approver1n2Data } from "../../../models/Approval/Approver1n2Data";
import { Margin } from "@mui/icons-material";
import ValidationErrors from "../../../components/ErrorList/ValidationErrors";
import { MasterDataUtil } from "../../../utils/masterData/MasterDataUtil";

export default function VendorBlocking(props: any) {

  const state = props.location.state;
  const vendorId = state ? state.vendorId : 0;
  const vendorNo = state ? state.vendorNo : "";
  const vendorType = state ? state.vendorType : "";
  const coCode = state ? state.coCode : "";
  const poCodes = state ? state.poCodes : [];
  const departmentList: Department[] = state ? state.departmentList : [];
  const requestNumber = state ? state.requestNumber : "";
  const createVendor: VendorCreateState = useSelector<RootState, VendorCreateState>((state) => state.vendorCreateDetails);

  const initialState: VendorBlockingData = {
    departmentId: 0,
    vendorId: vendorId,
    vendorNo: vendorNo,
    natureOfBlockId: 0,
    typeOfBlockIds: [],    
    reasonForBlockId: 0,
    vendorType: vendorType,
    reasonForBlock: "",
    companyCode: coCode,
    companyCodes: [coCode],
    poCodes: [],
    paymentBlockCode: "",
    blacklistProof: { fileId: 0, fileName: "", filePath: "" },
    rmCategoryIds: [],
    procurementCategoryIds: [],
    procurementSubcategoryIds: [],
    firstApprovers: [],
    secondApprovers: [],
    comment: "",
    spendManagedById: createVendor.SpendManagedById || 0,
    blockVendorCompany: [
      {
        typeOfBlockIds: [],
        reasonForBlockId: "0",
        reasonForBlock: "",
        companyCode: "",
        poCodes: [],
        paymentBlockCode: ""
      }
    ]
  };
  const [value, setValue] = React.useState(0);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  //let blacklistProof = { fileId:0, fileName: "", filePath:"" };
  const [vendorBlocking, setVendorBlocking] = useState<VendorBlockingData>(initialState);
  // const [selectedVendorBlock, setSelectedVendorBlock] = useState<VendorBlockingData>(initialState);
  const [isRMvendorsSelect, setisRMvendorsSelect] = useState(false);
  const [poList, setPoList] = useState(Array<Po>());
  //const [hodList, setHodList] = useState(Array<User>());
  //const [sbuList, setSBUList] = useState(Array<User>());
  //const [catLeadList, setCATLeadList] = useState(Array<User>());
  const [blockingTypeList, setBlockingTypeList] = useState(Array<BlockingType>());
  const [companyCodeList, setCompanyCodeList] = useState(Array<string>());
  const [paymentBlockCodeList, setPaymentBlockCodeList] = useState(Array<PaymemntBlock>());
  const BlockVendorData: VendorBlockData = useSelector<RootState, VendorBlockData>((state) => state.vendorBlockData);
  const sapVendorList: SAPVendor[] = useSelector<RootState, SAPVendor[]>((state) => state.vendorSearchData);
  const [procurementSubCategories, setProcurementSubCategories] = useState(Array<ProcurementSubcategorySummary>());
  const [rmCategories, setRMCategories] = useState(Array<RMCategory>());
  const [procurementCategories, setProcurementCategories] = useState(Array<ProcurementCategorySummary>());
  const [procurementSubCategorySummaries, setProcurementSubCategorySummaries] = useState(Array<ProcurementSubcategorySummary>());
  const [approver1List, setApprover1List] = useState(Array<User>());
  const [approver2List, setApprover2List] = useState(Array<User>());
  const [approver1Lable, setApprover1Lable] = useState("");
  const [approver2Lable, setApprover2Lable] = useState("");
  const [selectedVendorCompanyBlock, setSelectedVendorCompanyBlock] = React.useState(initialState.blockVendorCompany[0]);
  const tabRows = (vendorBlocking.blockVendorCompany ?? []).filter((row) => row.companyCode && row.companyCode.trim() !== "");
  const activeTabRow = tabRows[value] ?? null;
  const [blockingReasonList, setBlockingReasonList] = useState(Array<BlockingReason>());
  const [isReasonBlacklist, setIsReasonBlacklist] = useState(false);
  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const [, setIsCoCodeRequired] = useState(false);
  const [vendorCompanies, setVendorCompanies] = useState(Array<SAPVendor>());
  const [selectedCompanyPoList, setSelectedCompanyPoList] = useState(Array<Po>());
  const [selectedPoList, setSelectedPoList] = useState(Array<string>());
  const [selectedViewPo, setSelectedViewPo] = useState<string>("");
  const [relatedVendorCompanies, setRelatedVendorCompanies] = useState(Array<SAPVendor>());
  const [openValidateErrDialog, setOpenValidateErrDialog] = useState(false);

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string, duration?: number) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(message, messageduration!)
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(message, messageduration!)
        );
      }
    }
  };

  const getCompanyVendorBlockData = (coCode: string) => {
    //set new company data
    var companyBlock = vendorBlocking.blockVendorCompany.find(v => v.companyCode == coCode);
    if (!companyBlock) {
      companyBlock = {
        ...initialState.blockVendorCompany[0],
        "companyCode": coCode
      }
      vendorBlocking.blockVendorCompany.push(companyBlock);
    }
    companyBlock.poCodes = getRelatedPos(coCode);
    return companyBlock; 
  };

  const handletabsChange = (event: React.SyntheticEvent, coCode: string) => {
    setValue(1);

    if (selectedVendorCompanyBlock.companyCode != coCode) {
      //set current company data
      //setCompanyBlockFromSelected();
      //Load selected
      setSelectedVendorCompanyBlock(getCompanyVendorBlockData(coCode));
      setSelectedViewPo("");
      getExistingVendorBlock(coCode, "", false);
    }


  };

  // const setCompanyBlockFromSelected = () => {
  //   var currentComanyBlock = vendorBlocking.blockVendorCompany.find(v => v.companyCode == selectedVendorCompanyBlock.companyCode);
  //   if (currentComanyBlock) {
  //     currentComanyBlock.typeOfBlockIds = selectedVendorCompanyBlock.typeOfBlockIds;
  //     currentComanyBlock.reasonForBlockId = selectedVendorCompanyBlock.reasonForBlockId;
  //     currentComanyBlock.reasonForBlock = selectedVendorCompanyBlock.reasonForBlock;
  //     currentComanyBlock.companyCode = selectedVendorCompanyBlock.companyCode;
  //     currentComanyBlock.poCodes = selectedVendorCompanyBlock.poCodes;
  //     currentComanyBlock.paymentBlockCode = selectedVendorCompanyBlock.paymentBlockCode;
  //   }
  // }

  // const setApproverData = (users: User[], companyCode: string) => {
  //   let hodUsers: User[] = [];
  //   let sbuUsers: User[] = [];
  //   let catLeadUsers: User[] = [];
  //   if (users && users.length > 0) {
  //     users.forEach((u) => {
  //       let userCompany = u.userCompanies.find((c) => {
  //         return c.companyCode == companyCode;
  //       }) as UserCompany;
  //       if (userCompany.roleIds.find((r => { return r === App_Roles.HodApprover; }))) {
  //         hodUsers.push(u);
  //       }
  //       if (userCompany.roleIds.find((r => { return r === App_Roles.SBUSCHead; }))) {
  //         sbuUsers.push(u);
  //       }
  //       if (userCompany.roleIds.find((r => { return r === App_Roles.GSSCCategoryLead; }))) {
  //         catLeadUsers.push(u);
  //       }
  //     });

  //   }
  //   setHodList(hodUsers);
  //   setSBUList(sbuUsers);
  //   setCATLeadList(catLeadUsers);
  //   //setCompanyCodeList(companies);
  // };

  // const getApproverData = (companycode: string) => {
  //   //prepareForRequest();
  //   return MasterDataService.getUsersByRoles(
  //     companycode,
  //     [App_Roles.HodApprover, App_Roles.SBUSCHead, App_Roles.GSSCCategoryLead],
  //     function (users: User[]) {
  //       setApproverData(users, companycode);
  //     },
  //     function (error: Error) {
  //       setApproverData([], companycode);
  //     }
  //   );
  // };

  const clearApproverData = () => {
    setApprover1List([]);
    setApprover2List([]);
    setApprover1Lable("");
    setApprover2Lable("");
  }

  const getApproverData = (companyCode: string, vendorCategoryId: number, onBoardReasonIds: number[], isBulk: boolean, spendManagedById: number) => {
    return ApprovalPointUtil.getApproverData(companyCode, vendorCategoryId, onBoardReasonIds, isBulk
      , spendManagedById, RequestTypes.VendorExtend
      , (approver1n2Data: Approver1n2Data) => {
        setApprover1List(approver1n2Data.approver1List);
        setApprover2List(approver1n2Data.approver2List);
        setApprover1Lable(approver1n2Data.approver1Lable);
        setApprover2Lable(approver1n2Data.approver2Lable);
      });
  }

  const getRelatedPos = (coCode: string) => {
    let existingPos = relatedVendorCompanies.filter(v => v.compCode == coCode && v.poCodes && v.poCodes.length > 0)
            .flatMap(v => v.poCodes);
    return existingPos;
  }

  //load po list
  useEffect(() => {
    if (vendorBlocking.companyCode) {
      if (poCodes && poCodes.length > 0) {
        VendorDetailService.getPO(
          coCode,
          function (poData: Po[]) {
            poData = poData.filter((p) => {
              return poCodes.indexOf(p.code) > -1;
            });
            setPoList(poData);
          },
          function (error: Error) {
            setPoList([]);
          });
      }
      getApproverData(coCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
        , createVendor.IsBulk, (createVendor.SpendManagedById || 0));
    } else {
      setPoList([]);
      clearApproverData();
    }
  }, [vendorBlocking.companyCode]);

  useEffect(() => {
    if (vendorBlocking.companyCode && createVendor.VendorCategoryId > 0) {
      //if (!isInitialVendorDetailData) {
        //showLoadingMask();
        getApproverData(createVendor.CompanyCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
          , createVendor.IsBulk, createVendor.SpendManagedById || 0);
      //}
    } else {
      clearApproverData();
    }
  }, [createVendor.IsBulk, createVendor.SpendManagedById]);

  useEffect(() => {
      let selectedCoCodes = vendorBlocking.companyCodes;
      if (selectedCoCodes && selectedCoCodes.length > 0 ) {
        //add new
        selectedCoCodes.forEach(c => {
          let existingCo = vendorBlocking.blockVendorCompany.find(f => f.companyCode == c);
          if (!existingCo) {//add new
            vendorBlocking.blockVendorCompany.push({
              ...initialState.blockVendorCompany[0],
              "companyCode": c,
              "poCodes": getRelatedPos(c)
            });
          }
        });
        //delete
        vendorBlocking.blockVendorCompany = vendorBlocking.blockVendorCompany.filter(c => {
          return selectedCoCodes.indexOf(c.companyCode) > -1;
        });
        //set Pos
        let poCodes = relatedVendorCompanies.filter(v => selectedCoCodes.indexOf(v.compCode) > -1 
          && v.poCodes && v.poCodes.length > 0)
          .flatMap(v => v.poCodes.map(p => { return {companyCode: v.compCode, code: p, name: p }; }));
        setSelectedCompanyPoList(poCodes);
        setSelectedPoList(selectedPoList.filter(v => poCodes.find(p => p.code == v)));
        //approvers
        //TODO temp, later need to consider all companies      
        if (isRmOrNonRmOrServices()) {
          let coCode = selectedCoCodes && selectedCoCodes.length > 1
            ? selectedCoCodes[1] : selectedCoCodes[0];
          getApproverData(coCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
            , createVendor.IsBulk, (createVendor.SpendManagedById || 0));
        } else {
          //clearApproverData();
        }
      } else {
        clearApproverData();
        setSelectedCompanyPoList([]);
      }
    }, [vendorBlocking.companyCodes]);

  useEffect(() => {
    prepareForRequest();
    // setVendorBlocking({
    //   ...vendorBlocking!,
    //   ["vendorId"]: vendorId,
    // });
    //Set company list
    let vendorList = sapVendorList.filter(v => v.vendor == vendorNo && v.compCode[0] == coCode[0]);
    setVendorCompanies(vendorList);
    let coCodes = vendorList && vendorList.length > 0
      ? vendorList.map(v => v.compCode) : [];
    coCodes = coCodes.filter((item, index) => coCodes.indexOf(item) === index);
    setRelatedVendorCompanies(vendorList);
    setCompanyCodeList(coCodes);
    Promise.allSettled([
      VendorBlockingService.getBlockingMetaData(
        function (vendorBlockMetaData: VendorBlockMeta) {
          setBlockingTypeList(vendorBlockMetaData.blockType);
          //setBlockingNatureList(vendorBlockMetaData.natureOfBlock);
          //other reason added to table
          // let otherReason: BlockingReason = {
          //   code: "7",
          //   name: DropdownOptions_VendorBlocing_Reason.reasonOther,
          // };
          //vendorBlockMetaData.blockingReason.push(otherReason);
          setBlockingReasonList(vendorBlockMetaData.blockingReason);
          //compeleteRequest(true);
        },
        function (error: Error) {
          console.log(error);
          setBlockingTypeList([]);
          //setBlockingNatureList([]);
          setBlockingReasonList([]);
          //compeleteRequest(false);
        }
      ),
      VendorMasterData.GetPaymentBolcks(
        function (bockData: Array<PaymemntBlock>) {
          setPaymentBlockCodeList(bockData);
          //compeleteRequest(false);
        },
        function (error: Error) {
          setPaymentBlockCodeList([]);
          //compeleteRequest(false);
        }
      ),
      loadVendorMasterData()
    ]).then((values) => {
      compeleteRequest(true);
      console.log(values);
      //set selected values if block exists
      getExistingVendorBlock(coCode, "", true);
    });
  }, []);

  useEffect(() => {
    if (fistSubmitDone) {
      validateData();
    }
  }, [vendorBlocking]);

  useEffect(() => {
    const rowCount = vendorBlocking.blockVendorCompany?.length ?? 0;

    if (rowCount === 0) {
      if (value !== 0) {
        setValue(0);
      }
      return;
    }

    if (value > rowCount - 1) {
      setValue(0);
    }
  }, [vendorBlocking.blockVendorCompany, value]);

  useEffect(() => {
    if (vendorBlocking.procurementCategoryIds && vendorBlocking.procurementCategoryIds.length > 0) {
      //vendorExtendRequest.procurementSubcategoryIds = [];
      let procurementSubcats: ProcurementSubcategorySummary[] = [];
      procurementSubCategorySummaries.forEach(p => {
        if (vendorBlocking.procurementCategoryIds.find((e: number) => e == p.procurmentCategoryId)) {
          procurementSubcats.push(p);
        }
      });
      setProcurementSubCategories(procurementSubcats);
    } else {
      vendorBlocking.procurementSubcategoryIds = [];
      setProcurementSubCategories([]);
    }
  }, [vendorBlocking.procurementCategoryIds, procurementSubCategorySummaries]);

  const loadVendorMasterData = () => {
    if (createVendor.VendorCategoryId == VendorCategoryData.RM) {
      return getPromiseRMCategoryData(createVendor.VendorCategoryId);
    } else if (createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services) {
      return getPromiseProcurmentSubcategoryData(createVendor.VendorCategoryId);
    } else {
      return Promise.resolve();
    }
  }

  const getExistingVendorBlock = (coCode: string, poCode: string, isInitial: boolean) => {
    prepareForRequest();
    VendorBlockingService.getExistingVendorBlock(
      vendorNo,
      coCode,
      poCode,
      function (existingVendorBlock: VendorBlockingData) {
        let blockTypeIds = existingVendorBlock?.typeOfBlockIds ?? [];
        let reasonForBlockingId = existingVendorBlock?.reasonForBlockId ?? 0;
        let paymentBlockCode = existingVendorBlock?.paymentBlockCode ?? "";
        setSelectedVendorCompanyBlock({
          ...selectedVendorCompanyBlock,
          companyCode: coCode,
          poCodes: getRelatedPos(coCode),
          typeOfBlockIds: blockTypeIds ?? [],
          reasonForBlockId: reasonForBlockingId.toString() ?? "0",
          reasonForBlock: existingVendorBlock?.reasonForBlock ?? "",
          paymentBlockCode: paymentBlockCode ?? ""
        });
        // setSelectedVendorBlock({
        //   ...selectedVendorBlock,
        //   companyCode: coCode,
        //   companyCodes: [coCode],
        //   poCodes: poCode ? [poCode] : [],
        //   typeOfBlockIds: blockTypeIds ?? [],
        //   blockVendorCompany: existingVendorBlock?.blockVendorCompany ?? initialState.blockVendorCompany,
        //   reasonForBlockId: reasonForBlockingId ?? 0,
        //   reasonForBlock: existingVendorBlock?.reasonForBlock ?? "",
        //   paymentBlockCode: paymentBlockCode ?? "",
        //   rmCategoryIds: createVendor.RMCategoryIds,
        //   procurementCategoryIds: createVendor.ProcurementCategoryIds,
        //   procurementSubcategoryIds: createVendor.ProcurementSubcategoryIds,
        //   blacklistProof: existingVendorBlock?.blacklistProof ?? { fileId: 0, fileName: "", filePath: "" },
        //   comment: existingVendorBlock?.comment ?? "",
        // });
        if(isInitial){
          setVendorBlocking({
            ...initialState,
            //...existingVendorBlock ?? initialState),
            vendorId: vendorId,
            vendorNo: vendorNo,
            vendorType: vendorType,
            companyCode: coCode,
            companyCodes: [coCode],
            poCodes: poCode ? [poCode] : [],
            typeOfBlockIds: [],
            blockVendorCompany: existingVendorBlock?.blockVendorCompany ?? initialState.blockVendorCompany,
            reasonForBlockId: 0,
            reasonForBlock:  "",
            paymentBlockCode: paymentBlockCode ?? "",
            rmCategoryIds: createVendor.RMCategoryIds,
            procurementCategoryIds: createVendor.ProcurementCategoryIds,
            procurementSubcategoryIds: createVendor.ProcurementSubcategoryIds,
            blacklistProof: existingVendorBlock?.blacklistProof ?? { fileId: 0, fileName: "", filePath: "" },
            comment: existingVendorBlock?.comment ?? "",
          });

          existingVendorBlock.blockVendorCompany[0].poCodes = getRelatedPos(coCode)
          setSelectedVendorCompanyBlock(existingVendorBlock?.blockVendorCompany[0])
        }
        compeleteRequest(true);
      },
      function (error: Error) {
        console.log(error);
        compeleteRequest(false);
      }
    );
  };

  const getPromiseRMCategoryData = (vendorCategoryId: number) => {
    return MasterMetaDataService.getRMCategories(
      function (userRmCategoryList: Array<RMCategory>) {
        setRMCategories(userRmCategoryList);
      },
      function () {
        setRMCategories([]);
      }
    );
  };

  const loadProcurementCatList = (procurementCatList: ProcurementSubcategorySummary[]) => {
    let procurementCats: ProcurementCategorySummary[] = [];
    procurementCatList.forEach(p => {
      if (!procurementCats.find(e => e.procurmentCategoryId == p.procurmentCategoryId)) {
        procurementCats.push({
          vendorCategoryId: p.vendorCategoryId,
          procurmentCategoryId: p.procurmentCategoryId,
          procurmentCategoryName: p.procurmentCategoryName
        });
      }
    });
    setProcurementCategories(Util.sortObjByString(procurementCats, "procurmentCategoryName") as ProcurementCategorySummary[]);
  };

  const getPromiseProcurmentSubcategoryData = (vendorCategoryId: number) => {
    return MasterDataService.getProcurementSubcategorySummaries(
      RequestTypes.VendorExtend,
      vendorCategoryId,
      function (procurementCatList: Array<ProcurementSubcategorySummary>) {
        setProcurementSubCategorySummaries(Util.sortObjByString(procurementCatList, "procurmentCategoryName") as ProcurementSubcategorySummary[]);
        loadProcurementCatList(procurementCatList);
      },
      function () {
        setProcurementSubCategorySummaries([]);
      }
    );
  };

  const isRmOrNonRmOrServices = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services
      || createVendor.VendorCategoryId == VendorCategoryData.RM;
  };

  const isServicesBySbu = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.Services
      && (createVendor.SpendManagedById == SpendManagedByData.SBU
        || createVendor.SpendManagedById == SpendManagedByData.GroupProcurementAndSBU);
  };

  const isNonRmOrServices = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services;
  };

  // const isCompanyBlockAllowed = (coList: string[]) => {
  //   //if source company po extended
  //   var selectedCompanyBlock = vendorBlocking.blockVendorCompany.find(v => v.companyCode == )
  //   var originCoExtend = selectedCompnayExtend.coCode == companyCode
  //     ? selectedCompnayExtend
  //     : vendorExtendRequest.companyExtendDataList.find(v => v.coCode == companyCode);
  //   var isOriginPoExtended = originCoExtend?.poCode && originCoExtend?.poCode.length > 0;

  //   let otherCos = coList && coList.length > 0
  //     ? coList.filter(c => isOriginPoExtended || c != companyCode) : [];
  //   if (otherCos.length > 1 && otherCos.find(o => otherCos[0][0] != o[0])) {//First char same within cluster
  //     dispatch(AllActions.infoActions.openInforWarn(
  //       translation.vendor_extend_allow_multiselect_incluster_msg,
  //       InforDisplyaDuration.common
  //     ));
  //     return false
  //   }
  //   return true;
  // }

  const handleChange = (input: string) => (e: any) => {
    if (input === "reasonForBlockId") {
      const nextReasonId = e.target.value;

      if (nextReasonId == DropdownOptions_VendorBlocing_Reason.blacklistedVendor.toString()) {
        setIsReasonBlacklist(true);
      } else {
        setIsReasonBlacklist(false);
      }
      setVendorBlocking({
        ...vendorBlocking,
        reasonForBlockId : nextReasonId
      });
    } else if (input === "rmCategoryIds" ) {
      setVendorBlocking({ ...vendorBlocking!, [input]: e.target.value ? [e.target.value] : [] });
    } else if (input === "procurementSubcategoryIds") {
      let procSubCatId = e.target.value;
      if(procSubCatId > 0){
        let procCat = procurementSubCategorySummaries.find(p => p.procurmentSubcategoryId == procSubCatId);
        if(procCat){
          dispatch(AllActions.vendorCreationActions.updateDataField("SpendManagedById", procCat.spendManagedById));
        }
      }
      setVendorBlocking({ ...vendorBlocking!, [input]: e.target.value ? [e.target.value] : [] });
    } else if (input === "procurementCategoryIds") {
      setProcurementSubCategories([]);
      setVendorBlocking({
        ...vendorBlocking!
        , "procurementSubcategoryIds": []
        , [input]: e.target.value ? [e.target.value] : []
      });
    }
    else if (input === "typeOfBlockIds") {
      const blockTypeIds = e.target.value as number[];
      if (blockTypeIds.includes(DropdownOptions_VendorBlocking_Type.AllPoBlock) 
        || blockTypeIds.includes(DropdownOptions_VendorBlocking_Type.AllCompanyBlock)
      ) {
        setIsCoCodeRequired(false);
      } else {
        setIsCoCodeRequired(true);
      }
      setVendorBlocking({
        ...vendorBlocking,
        "typeOfBlockIds": blockTypeIds
      });
      // setVendorBlocking((prev) => {
      //   const prevSafe = prev ?? initialState;
      //   return {
      //     ...prevSafe,
      //     typeOfBlockIds: nextTypeIds,
      //     blockVendorCompany: (prevSafe.blockVendorCompany ?? []).map((row) => ({
      //       ...row,
      //       typeOfBlockIds: nextTypeIds,
      //     })),
      //   };
      // });
    }
    else if (input === "companyCodes") {
      const companyCodes = e.target.value 
        ? e.target.value  as string[] : [];
      if (companyCodes.indexOf(coCode) > -1) { //avoiding deleting initial company
        setVendorBlocking({
          ...vendorBlocking,
          "companyCodes": companyCodes
        });  
      }    
      // if (selectedCos.indexOf(coCode) > -1 //avoiding deleting initial company
      //   && isCompanyBlockAllowed(selectedCos)) {//allow multiselect within cluster
      //   setSelectedCoCodes(e.target.value as string[]);
      // }  
      // setVendorBlocking((prev) => {
      //   const prevSafe: VendorBlockingData = prev ?? initialState;
      //   const nextBlockVendorCompany = buildBlockVendorCompany(nextCodes, prevSafe);
      //   return {
      //     ...prevSafe,
      //     companyCodes: nextCodes,
      //     blockVendorCompany: nextBlockVendorCompany,
      //   };
      // });
      // setValue(0);
    } else if (input === "companyCode") {
      setVendorBlocking({
        ...vendorBlocking!,
        [input]: e.target.value,
        poCodes: [],
      });
    } else if (input === "poCodes") {
      setVendorBlocking({
        ...vendorBlocking!,
        [input]: [e.target.value],
      });
    } else if (input === "viewPo") {
      setSelectedViewPo(e.target.value);
      getExistingVendorBlock(selectedVendorCompanyBlock.companyCode
        ,e.target.value ? e.target.value : "", false
      );
    } else if (input === "blockPo") {
      setSelectedPoList(e.target.value);
    }
    else if (input === "reasonForBlock") {
      const nextReason = e.target.value;

      setVendorBlocking((prev) => {
        const prevSafe = prev ?? initialState;

        return {
          ...prevSafe,
          reasonForBlock: nextReason,
          blockVendorCompany: (prevSafe.blockVendorCompany ?? []).map((row) => ({
            ...row,
            reasonForBlock: nextReason,
          })),
        };
      });
    }
    else {
      setVendorBlocking((prev) => ({
        ...(prev ?? initialState),
        [input]: e.target.value,
      }));
    }
  };

  const getErrorState = (input: string) => {
    // console.log("getErrorState");
    var errIndex = formErrors.findIndex(function (row) {
      return row.fieldName === input && row.errorMsg;
    });
    return errIndex !== -1 ? true : false;
  };

  const getBlockTypeName = (blockTypeId: number) => {
    let type = blockingTypeList.find(b => {
      return b.id == blockTypeId;
    });
    return type ? type.name : '';
  };

  const validateData = () => {
    //setFormErrors([]);
    let valid = true;
    const validateFieldsData: Array<FormFieldMeta> = [
      {
        fieldName: "departmentId",
        isRequired: true,
        reuiredMsg: "Department required",
        isList: true,
      },
      {
        fieldName: "typeOfBlockIds",
        isRequired: false,
        reuiredMsg: "Block Type required",
        isList: true,
      },
      {
        fieldName: "companyCodes",
        isRequired: false,
        reuiredMsg: "company Codes required",
        isList: true,
      },


      // {
      //   fieldName: "natureOfBlockId",
      //   isRequired: true,
      //   reuiredMsg: "NatureOfBlock is required",
      // },
      {
        fieldName: "reasonForBlockId",
        isRequired: (vendorBlocking.typeOfBlockIds && vendorBlocking.typeOfBlockIds.length > 0 ? true : false),
        reuiredMsg: "Blocking Reason is required",
      },
      {
        fieldName: "reasonForBlock",
        isRequired: (vendorBlocking.reasonForBlockId == DropdownOptions_VendorBlocing_Reason.reasonOther),
        reuiredMsg: "Reason For Block is required",
      },
      // {
      //   fieldName: "poCodes",
      //   isRequired: vendorBlocking.typeOfBlockIds.includes(
      //     DropdownOptions_VendorBlocking_Type.SelectedCompanyBlock
      //   )
      //     ? true
      //     : false,
      //   reuiredMsg: "Po Codes required",
      //   isList: true,
      // },
      // {
      //   fieldName: "hodApprovers",
      //   isRequired: false,//(vendorType === VendorTypeData.RMProductionRelated) ? false : true,
      //   reuiredMsg: "HOD Approvers required",
      //   isList: true,
      // },
      {
        fieldName: "rmCategoryIds",
        isRequired: createVendor.VendorCategoryId == VendorCategoryData.RM ? true : false,
        reuiredMsg: "RM Category is required",
        isList: true
      },
      {
        fieldName: "procurementCategoryIds",
        isRequired: isNonRmOrServices(),
        reuiredMsg: "Procurement Category is required",
        isList: true
      },
      {
        fieldName: "procurementSubcategoryIds",
        isRequired: isNonRmOrServices(),
        reuiredMsg: "Procurement Subcategory is required",
        isList: true
      },
      {
        fieldName: "firstApprovers",
        isRequired: !isRmOrNonRmOrServices() || isServicesBySbu(),
        reuiredMsg: approver1Lable + " required",
        isList: true,
      },
      // {
      //   fieldName: "catLeadApprovers",
      //   isRequired: false,
      //   reuiredMsg: "catLead Approvers required",
      //   isList: true,
      // },
      // {
      //   fieldName: "companyCode",
      //   isRequired: isCoCodeRequired,
      //   reuiredMsg: "CompanyCode is required",
      // },
    ];
    var tempArray: Array<FormError> = [];
    let len = validateFieldsData.length;
    //check rquired
    for (let index = 0; index < len; index++) {
      var fieldData = validateFieldsData[index];

      if (fieldData.isRequired) {
        if (
          vendorBlocking &&
          (!vendorBlocking[fieldData.fieldName] ||
            (fieldData.isList &&
              vendorBlocking[fieldData.fieldName].length === 0))
        ) {
          tempArray.push({
            fieldName: fieldData.fieldName,
            errorMsg: fieldData.reuiredMsg!,
          });
          valid = false;
        }
      }
    }
    // //Po
    // if(!vendorBlocking.typeOfBlockIds.includes(DropdownOptions_VendorBlocking_Type.SelectedPoBlock)){
    //   tempArray.push({ fieldName: "Purch Org", errorMsg: "Purch Org required."});
    // }
    //Po
    if(selectedPoList.length == 0 && vendorBlocking.typeOfBlockIds.includes(DropdownOptions_VendorBlocking_Type.SelectedPoBlock)){
      tempArray.push({ fieldName: "Purch Org", errorMsg: "Purch Org required."});
      valid = false;
    }
    setFormErrors(tempArray);
    return valid;
  };

  const getPoCompanyCode = (poCode: string) => {
    var co = relatedVendorCompanies.find(v => v.poCodes && v.poCodes.indexOf(poCode) > -1);
    return co?.compCode;
  }

  const setBlockPoCodes = () => {
    vendorBlocking.blockVendorCompany.forEach(vb => {
      var poCodes = selectedPoList.filter(p => vb.companyCode == getPoCompanyCode(p));
      vb.poCodes = poCodes;
    });
  }

  const handleSubmit = (e: any) => {
    setFistSubmitDone(true);
    setOpenValidateErrDialog(false);
    if (validateData()) {
      prepareForRequest();
      setBlockPoCodes();
      VendorBlockingService.submitVendorBlockRequest(
        vendorBlocking!,
        function (vendorBlockData: any) {
          console.log(vendorBlockData);
          if(vendorBlockData.resposeObjectType == 1) {//success
            compeleteRequest(
              true,
              `${vendorBlockData.result} ${translation.vendor_block_submit_success_msg}`,
              InforDisplyaDuration.approvalStatus
            );
            //compeleteRequest(true, translation.vendor_block_submit_success_msg);
            // dispatch(
            //   AllActions.vendorCreationActions.updateForm1Details(vendorData)
            // );
            history.push(NavigationPaths.Dashboard);
          } else {
            compeleteRequest(false, translation.vendor_block_submit_error_amend_required_msg);
          }
        },
        function (error: Error) {
          console.log(error);
          compeleteRequest(false, translation.vendor_block_submit_error_msg);
        }
      );
    }else{
      //show errors list
      setOpenValidateErrDialog(true);
    }
  };
  function handleOnBlur(input: string): (e: any) => void {
    return (e: any) => {
      setVendorBlocking({
        ...vendorBlocking!,
        [input]: e.target.value,
      });
    };
  }
  /*   const handleDelete = (e: React.MouseEvent, value: string, input: string) => {
      e.preventDefault();
      if (input === "poCodes") {
        setVendorBlocking({
          ...vendorBlocking!,
          ["poCodes"]: vendorBlocking.poCodes.filter((code: string) => {
            return code !== value;
          }),
        });
      } else if (input === "hodApprovers") {
        setVendorBlocking({
          ...vendorBlocking!,
          ["hodApprovers"]: vendorBlocking.hodApprovers.filter((code: string) => {
            return code !== value;
          }),
        });
         } else if (input === "sbuApprovers") {
        setVendorBlocking({
          ...vendorBlocking!,
          ["sbuApprovers"]: vendorBlocking.sbuApprovers.filter((code: string) => {
            return code !== value;
          }),
        });
         } else if (input === "catLeadApprovers") {
        setVendorBlocking({
          ...vendorBlocking!,
          ["catLeadApprovers"]: vendorBlocking.catLeadApprovers.filter((code: string) => {
            return code !== value;
          }),
        });
  
        
      } 
  
  else if (input === "typeOfBlockIds") {else if (input === "type nextTypeIds = vendorBlocking.typeOfBlockIds.filter((code: string) => code !== value);
  
    if (
      nextTypeIds.includes(DropdownOptions_VendorBlocking_Type.masAllBlockPo) ||
      nextTypeIds.includes(DropdownOptions_VendorBlocking_Type.masAllBlockService)
    ) {
      setIsCoCodeRequired(false);
    } else {
      setIsCoCodeRequired(true);
    }
  
    setVendorBlocking((prev) => {
      const prevSafe = prev ?? initialState;
  
      return {
        ...prevSafe,
        typeOfBlockIds: nextTypeIds,
        blockVendorCompany: (prevSafe.blockVendorCompany ?? []).map((row) => ({
          ...row,
          typeOfBlockIds: nextTypeIds,
        })),
      };
    });
  }
  
  
  
  else if (input === "companyCodes") {
    const nextCodes = vendorBlocking.companyCodes.filter(
      (code: string) => code !== value
    );
  
    setVendorBlocking((prev) => {
      const prevSafe = prev ?? initialState;
  
      return {
        ...prevSafe,
        companyCodes: nextCodes,
        blockVendorCompany: buildBlockVendorCompany(nextCodes, prevSafe),
      };
    });
  
    setValue(0);
  }
  
  
    }; */

  const handleDelete = (e: React.MouseEvent, value: any, input: string) => {
    e.preventDefault();
    if (input === "poCodes") {
      setVendorBlocking({
        ...vendorBlocking!,
        poCodes: (vendorBlocking.poCodes ?? []).filter(
          (code: string) => code !== value
        ),
      });
    } else if (input === "typeOfBlockIds") {
      const blockTypeIds = (vendorBlocking.typeOfBlockIds ?? []).filter(
        (id) => id !== value
      );
      if (blockTypeIds.includes(DropdownOptions_VendorBlocking_Type.AllPoBlock) 
        || blockTypeIds.includes(DropdownOptions_VendorBlocking_Type.AllCompanyBlock)
      ) {
        setIsCoCodeRequired(false);
      } else {
        setIsCoCodeRequired(true);
      }
      setVendorBlocking({
        ...vendorBlocking,
        "typeOfBlockIds": blockTypeIds
      });
      // setVendorBlocking((prev) => {
      //   const prevSafe = prev ?? initialState;

      //   return {
      //     ...prevSafe,
      //     typeOfBlockIds: nextTypeIds,
      //     blockVendorCompany: (prevSafe.blockVendorCompany ?? []).map((row) => ({
      //       ...row,
      //       typeOfBlockIds: nextTypeIds,
      //     })),
      //   };
      // });
    } else if (input === "companyCodes") {
      if(value != coCode){//avoid deleting initial
        let coBlocks = vendorBlocking.blockVendorCompany
          .filter(b => b.companyCode != value)
          .map(b => b.companyCode);

        setVendorBlocking({
          ...vendorBlocking,
          "companyCodes": coBlocks
        });
      }
    } else if (input === "blockPo") {
      setSelectedPoList(selectedPoList.filter(p => p != value));
    }
  };

  // const codeToName = React.useMemo(() => {
  //   const dict = new Map<string, string>();
  //   blockingTypeList?.forEach(bt => dict.set(bt.code, bt.name));
  //   return dict;
  // }, [blockingTypeList]);

  // // Map selected codes -> names (ordered by typeOfBlockIds)
  // const selectedTypeNames = React.useMemo(() => {
  //   const ids = vendorBlocking?.typeOfBlockIds ?? [];
  //   return ids
  //     .map(code => codeToName.get(code))
  //     .filter((n): n is string => Boolean(n));
  // }, [vendorBlocking?.typeOfBlockIds, codeToName]);

  // Utility to rebuild blockVendorCompany from selected company codes,
  // preserving existing entries' poCodes (and any other fields you want to keep).

  // function buildBlockVendorCompany(selectedCodes: string[], current: VendorBlockingData): BlockVendorCompany[] {
  //   const mapExisting = new Map(
  //     (current.blockVendorCompany ?? [])
  //       .filter((b) => b.companyCode && b.companyCode.trim() !== "")
  //       .map((b) => [b.companyCode, b] as const)
  //   );

  //   return selectedCodes.map<BlockVendorCompany>((code) => {
  //     const existing = mapExisting.get(code);

  //     return {
  //       companyCode: code,
  //       typeOfBlockIds: existing?.typeOfBlockIds ?? current.typeOfBlockIds ?? [],
  //       reasonForBlockId: existing?.reasonForBlockId ?? String(current.reasonForBlockId ?? ""),
  //       reasonForBlock: existing?.reasonForBlock ?? current.reasonForBlock ?? "",
  //       poCodes: existing?.poCodes ?? [],
  //       paymentBlockCode: existing?.paymentBlockCode ?? current.paymentBlockCode ?? ""
  //     };
  //   });
  // }

  const updateActiveCompanyRow = (patch: Partial<BlockVendorCompany>) => {
    setVendorBlocking((prev) => {
      const prevSafe = prev ?? initialState;
      const rows = [...(prevSafe.blockVendorCompany ?? [])];

      if (!rows[value]) {
        return prevSafe;
      }

      rows[value] = {
        ...rows[value],
        ...patch,
      };

      return {
        ...prevSafe,
        blockVendorCompany: rows,
      };
    });
  };

  const getBlockTypeNames = (ids: number[] = []) => {
    return blockingTypeList.filter(v => ids.indexOf(v.id) > -1)
      .map((bt) => bt.name)
      .join(",");
  };

  return (
    <div>
      <div className={classes.contentOuterBG}>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}
          className={classes.createHeader} >
          <span className={classes.createHeaderTxt}>
            {translation.vendor_block_blocking_section_title}
          </span>
          <span className={classes.createHeaderLine}></span>
        </Grid>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.createWrapper} >
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_department_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
              <Select
                variant="outlined"
                value={vendorBlocking.departmentId}
                onChange={handleChange("departmentId")}
                error={getErrorState("departmentId")}
              >
                {departmentList.map((obj, index) => (
                  <MenuItem key={obj.id} value={obj.id}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_comment_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
              <TextField
                variant="outlined"
                value={vendorBlocking.comment || ""}
                onChange={handleChange("comment")}
                error={getErrorState("comment")}
                inputProps={{ maxLength: FieldsLengthConstants.RequestComments }}
                onBlur={handleOnBlur("comment")}
              />
            </Grid>
          </Grid>
          {/* <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_co_lbl}
              </span>
            </Grid>
            <Grid //className={(isCoCodeRequired ? classes.inputWrapper_Req : classes.inputWrapper )}
              className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
              <TextField
                disabled
                variant="outlined"
                value={vendorBlocking?.companyCode || ""}
              />
            </Grid>
          </Grid> */}
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_co_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper}
              item xs={12} sm={12} md={12} lg={12}>
              <Select
                variant="outlined"
                multiple
                value={vendorBlocking.companyCodes ?? []}
                onChange={handleChange("companyCodes")}
                error={getErrorState("companyCodes")}
                renderValue={(selected) => {
                  const selectedCodes = (selected as string[]) ?? [];
                  return (
                    <div>
                      {selectedCodes.map((code) => {
                        return (
                          <Chip
                            key={code}
                            label={code}
                            clickable
                            deleteIcon={
                              <CancelIcon onMouseDown={(event) => event.stopPropagation()} />
                            }
                            onDelete={(e) => handleDelete(e, code, "companyCodes")}
                          />
                        );
                      })}
                    </div>
                  );
                }}
              >
                {companyCodeList.map((item) => (
                  <MenuItem key={item} value={item}>
                    <Checkbox checked={(vendorBlocking.companyCodes ?? []).includes(item)} />
                    <ListItemText primary={item} />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_po_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper}
              item xs={12} sm={12} md={12} lg={12}>
              <Select
                variant="outlined"
                multiple
                value={selectedPoList ?? []}
                onChange={handleChange("blockPo")}
                error={getErrorState("blockPo")}
                renderValue={(selected) => {
                  const selectedPoCodes = selected as string[];
                  const selectedPos = selectedCompanyPoList.filter(p => selectedPoCodes.indexOf(p.code) > -1);
                  return (
                    <div>
                      {selectedPos.map((po) => {
                        return (
                          <Chip
                            key={po.code}
                            label={ `${po.companyCode}-${po.code}` }
                            clickable
                            deleteIcon={
                              <CancelIcon onMouseDown={(event) => event.stopPropagation()} />
                            }
                            onDelete={(e) => handleDelete(e, po.code, "blockPo")}
                          />
                        );
                      })}
                    </div>
                  );
                }}
              >
                {selectedCompanyPoList.map((item) => (
                  <MenuItem key={item.code} value={item.code}>
                    <Checkbox checked={(selectedPoList ?? []).includes(item.code)} />
                    <ListItemText primary={`${item.companyCode}-${item.code}`} />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          {createVendor.VendorCategoryId == VendorCategoryData.RM && (
            <Fragment>
              {/* <Grid item container xs={12} sm={12} md={6} lg={4} >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.vendor_crete_form1_BulkSample_lbl}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} style={{ width: "50%", float: "left" }}>
                  <span>{createVendor.IsBulk ? "Bulk" : "Sample"}</span>
                </Grid>
              </Grid> */}
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.vendor_crete_form1_RMCategory_lbl}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper_Req}>
                  <Select
                    variant="outlined"
                    value={vendorBlocking.rmCategoryIds[0] || 0}
                    onChange={handleChange("rmCategoryIds")}
                    inputProps={{ readOnly: createVendor.RMCategoryIds && createVendor.RMCategoryIds.length > 0 }}
                    error={getErrorState("rmCategoryIds")}
                  >
                    <MenuItem value="">
                      <em>{translation.dropdown_empty_text}</em>
                    </MenuItem>
                    {rmCategories.map((obj) => (
                      <MenuItem key={obj.id} value={obj.id}>
                        {obj.rmCategoryName}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </Fragment>)
          }
          {(createVendor.VendorCategoryId == VendorCategoryData.NonRM
            || createVendor.VendorCategoryId == VendorCategoryData.Services
          ) && (
              <Fragment>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_crete_form1_procurement_cat_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req}>
                    <Select
                      variant="outlined"
                      value={vendorBlocking.procurementCategoryIds[0] || 0}
                      onChange={handleChange("procurementCategoryIds")}
                      inputProps={{ readOnly: createVendor.ProcurementSubcategoryIds && createVendor.ProcurementSubcategoryIds.length > 0 }}
                      error={getErrorState("procurementCategoryIds")}
                    >
                      <MenuItem value="">
                        <em>{translation.dropdown_empty_text}</em>
                      </MenuItem>
                      {procurementCategories.map((obj) => (
                        <MenuItem key={obj.procurmentCategoryId} value={obj.procurmentCategoryId}>
                          {obj.procurmentCategoryName}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <span className={classes.createLbl}>
                      {translation.vendor_crete_form1_procurement_subcat_lbl}
                    </span>
                  </Grid>
                  <Grid className={classes.inputWrapper_Req}>
                    <Select
                      variant="outlined"
                      value={vendorBlocking.procurementSubcategoryIds[0] || 0}
                      onChange={handleChange("procurementSubcategoryIds")}
                      inputProps={{ readOnly: createVendor.ProcurementSubcategoryIds && createVendor.ProcurementSubcategoryIds.length > 0 }}
                      error={getErrorState("procurementSubcategoryIds")}
                    >
                      <MenuItem value="">
                        <em>{translation.dropdown_empty_text}</em>
                      </MenuItem>
                      {procurementSubCategories.map((obj) => (
                        <MenuItem key={obj.procurmentSubcategoryId} value={obj.procurmentSubcategoryId}>
                          {MasterDataUtil.getNameFromProcSubCategorName(obj.procurmentSubcategoryName)}
                        </MenuItem>
                      ))}
                    </Select>
                    <span className={classes.helpLbl}>{
                      MasterDataUtil.getSpendMngByFromProcSubCategorId(procurementSubCategories
                      ,vendorBlocking.procurementSubcategoryIds[0] || 0)}
                    </span>
                  </Grid>
                </Grid>
              </Fragment>)
          }
          {/*  <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_po_lbl}
              </span>
            </Grid>
            <Grid
              className={classes.inputWrapper}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Select
                variant="outlined"
                value={vendorBlocking?.poCodes[0] || ""}
                onChange={handleChange("poCodes")}
                error={getErrorState("poCodes")}
              >
                {poList.map((obj, index) => (
                  <MenuItem key={obj.code} value={obj.code}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid> */}
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_type_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper}
              item xs={12} sm={12} md={12} lg={12} >
              <Select
                variant="outlined"
                multiple
                value={vendorBlocking.typeOfBlockIds || []}
                onChange={handleChange("typeOfBlockIds")}
                error={getErrorState("typeOfBlockIds")}
                renderValue={(selected) => (
                  <div>
                    {(selected as number[]).map((value) => (
                      <Chip
                        key={value}
                        label={getBlockTypeName(value)}
                        clickable
                        deleteIcon={
                          <CancelIcon
                            onMouseDown={(event) => event.stopPropagation()}
                          />
                        }
                        onDelete={(e) =>
                          handleDelete(e, value, "typeOfBlockIds")
                        }
                        onClick={() => console.log("clicked chip")}
                      />
                    ))}
                  </div>
                )}
              >
                {blockingTypeList.map((obj, index) => (
                  <MenuItem key={obj.id} value={obj.id}>
                    <Checkbox
                      checked={(vendorBlocking.typeOfBlockIds ?? []).includes(obj.id)}
                    />
                    <ListItemText primary={obj.name} />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid hidden={!vendorBlocking.typeOfBlockIds || vendorBlocking.typeOfBlockIds.length == 0}
            item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_reason_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req}
              item xs={12} sm={12} md={12} lg={12} >
              <Select
                variant="outlined"
                value={vendorBlocking?.reasonForBlockId}
                onChange={handleChange("reasonForBlockId")}
                error={getErrorState("reasonForBlockId")}
              >
                {blockingReasonList.map((obj, index) => (
                  <MenuItem key={obj.id} value={obj.id}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          {/* if reason for block = other then show */}
          <Grid hidden={vendorBlocking?.reasonForBlockId != DropdownOptions_VendorBlocing_Reason.reasonOther} item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_reason_other_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req}
              item xs={12} sm={12} md={12} lg={12} >
              <TextField
                variant="outlined"
                value={vendorBlocking.reasonForBlock || ""}
                onChange={handleChange("reasonForBlock")}
                error={getErrorState("reasonForBlock")}
                inputProps={{
                  maxLength: FieldsLengthConstants.BlockReasonOther,
                }}
                onBlur={handleOnBlur("reasonForBlock")}
              />
            </Grid>
          </Grid>
          <Grid hidden={!isReasonBlacklist} item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_reasonupload_lbl}
              </span>
            </Grid>
            <Grid
              className={classes.formOneinputWrapper}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <div className={classes.fileWrapper}>
                <FileUpload
                  editable={true}
                  requestNumber={requestNumber}
                  //onFileUpload = {(fileId:number) => { onFileUpload(fileId) }}
                  userfile={vendorBlocking?.blacklistProof!}
                  //userfile={blacklistProof}
                  attachmentType={FileUploadTypes.BlacklistProof}
                ></FileUpload>
              </div>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_paymentblock_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
              <Select
                variant="outlined"
                value={vendorBlocking?.paymentBlockCode || ""}
                onChange={handleChange("paymentBlockCode")}
                error={getErrorState("paymentBlockCode")}
              >
                {paymentBlockCodeList.map((obj, index) => (
                  <MenuItem key={obj.code} value={obj.code}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </Grid>
        {approver1List && approver1List.length > 0 && (
          <Fragment>
            <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} >
              <span className={classes.createHeaderTxt}>
                {translation.vendor_crete_form1_approvers_section_title}
              </span>
              <span className={classes.createHeaderLine}></span>
            </Grid>
            <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>{approver1Lable}</span>
                </Grid>
                <Grid className={classes.inputWrapper_Req}>
                  {(!isRmOrNonRmOrServices() || isServicesBySbu()) && (
                    <Select
                    variant="outlined"
                    multiple
                    value={vendorBlocking.firstApprovers || []}
                    onChange={handleChange("firstApprovers")}
                    error={getErrorState("firstApprovers")}
                    renderValue={(selected) => (
                      <div>
                        {(selected as string[]).map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            clickable
                            deleteIcon={
                              <CancelIcon
                                onMouseDown={(event) => event.stopPropagation()}
                              />
                            }
                            onDelete={(e) => handleDelete(e, value, "firstApprovers")}
                          />
                        ))}
                      </div>
                    )}
                  >
                    {approver1List.map((obj) => (
                      <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                        <Checkbox
                          checked={vendorBlocking.firstApprovers.includes(obj.emailAddress)}
                        />
                        <ListItemText primary={obj.emailAddress} />
                      </MenuItem>
                    ))}
                  </Select>)}
                  {(isRmOrNonRmOrServices() && !isServicesBySbu()) && (
                    <span className={classes.textWrap}>
                      {`${approver1List.map((obj) => obj.emailAddress + ' ')}`}
                    </span>
                  )}
                </Grid>
              </Grid>
              {/* {approver2List.length > 0 && (<Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>{approver2Lable}</span>
                </Grid>
                <Grid className={classes.inputWrapper_Req}>
                  {!isRmOrNonRmOrServices() && (<Select
                    variant="outlined"
                    multiple
                    value={vendorExtendRequest.secondApprovers || []}
                    onChange={handleChange("secondApprovers")}
                    error={getErrorState("secondApprovers")}
                    renderValue={(selected) => (
                      <div>
                        {(selected as string[]).map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            clickable
                            deleteIcon={
                              <CancelIcon
                                onMouseDown={(event) => event.stopPropagation()}
                              />
                            }
                            onDelete={(e) => handleDelete(e, value, "secondApprovers")}
                          />
                        ))}
                      </div>
                    )}
                  >
                    {approver2List.map((obj) => (
                      <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                        <Checkbox
                          checked={vendorExtendRequest.secondApprovers.includes(obj.emailAddress)}
                        />
                        <ListItemText primary={obj.emailAddress} />
                      </MenuItem>
                    ))}
                  </Select>)}
                  {isRmOrNonRmOrServices() && (
                    <span className={classes.textWrap}>
                      {`${approver2List.map((obj) => obj.emailAddress + ' ')}`}
                    </span>
                  )}
                </Grid>
              </Grid>)} */}
            </Grid>
          </Fragment>)
        }

      </div>

      <div className={classes.contentOuterBG}>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}
          className={classes.createHeader} >
          <span className={classes.createHeaderTxt}>
            {translation.vendor_block_blocking_section_view_title}
          </span>
          <span className={classes.createHeaderLine}></span>
        </Grid>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "15px !important" }}>
          <Tabs value={selectedVendorCompanyBlock.companyCode || 0} onChange={handletabsChange}>
            {vendorBlocking.companyCodes.map((coCode) => (
              <Tab label={coCode} value={coCode} />
            ))
            }
          </Tabs>
        </Grid>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.createWrapper} >
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_po_lbl}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper} item xs={12} sm={12} md={12} lg={12} >
              <Select
                variant="outlined"
                value={selectedViewPo || ""}
                onChange={handleChange("viewPo")}
                //error={getErrorState("viewPo")} 
              >
                <MenuItem key='' value = ''>None</MenuItem>
                {selectedVendorCompanyBlock.poCodes.map((obj, index) => (
                  <MenuItem key={obj} value={obj}>
                    {obj}
                  </MenuItem> 
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_type_lbl}
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper}
              item xs={12} sm={12} md={12} lg={12} >
              <span className={classes.textWrap}>
                { getBlockTypeNames(selectedVendorCompanyBlock.typeOfBlockIds) }
              </span>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.vendor_block_blocking_paymentblock_lbl}
              </span>
            </Grid>
            <Grid className={classes.formOneinputWrapper}
              item xs={12} sm={12} md={12} lg={12} >
              <span className={classes.textWrap}>
                {paymentBlockCodeList.find((x) => x.code === selectedVendorCompanyBlock?.paymentBlockCode)?.name || ""}
              </span>
            </Grid>
          </Grid>
        </Grid>
      </div>








      {/* 


      <Box sx={{ width: "100%", mt: 3 }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handletabsChange} aria-label="company tabs">
            {tabRows.map((row, index) => (
              <Tab key={row.companyCode} label={row.companyCode} value ={row.companyCode} />
            ))}
          </Tabs>
        </Box>

        {tabRows.map((row, index) => {
          const rowTypeNames = getTypeNames(row.typeOfBlockIds ?? []);

          return (
            <CustomTabPanel key={row.companyCode} value={value} index={index}>
              <Gridm container spacing={2}>
                <Gridm item xs={12} sm={4}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "text.secondary",
                        mb: 0.5,
                        fontWeight: "bold",
                        textAlign: "left",
                        width: "100%",
                      }}
                    >
                      Payment Block
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      {paymentBlockCodeList.find((x) => x.code === vendorBlocking?.paymentBlockCode)?.name || ""}
                    </Typography>
                  </Box>
                </Gridm>
                <Gridm item xs={12} sm={4}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "text.secondary",
                        mb: 0.5,
                        fontWeight: "bold",
                        textAlign: "left",
                        width: "100%",
                      }}
                    >
                      Block Type
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 700, wordBreak: "break-word" }}
                      title={rowTypeNames.join(", ")}
                    >
                      {rowTypeNames.length ? rowTypeNames.join(", ") : "—"}
                    </Typography>
                  </Box>
                </Gridm>

                <Gridm item xs={12} sm={4}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "text.secondary",
                        mb: 0.5,
                        fontWeight: "bold",
                        textAlign: "left",
                        width: "100%",
                      }}
                    >
                      PO Code
                    </Typography>


                    <FormControl size="small" sx={{ maxWidth: 260, width: "100%" }}>
                      <Select
                        value={row.poCodes?.[0] ?? ""}
                        onChange={(e) => {
                          const selectedPo = e.target.value as string;

                          updateActiveCompanyRow({
                            poCodes: selectedPo ? [selectedPo] : [],
                          });

                          setVendorBlocking((prev) => {
                            const prevSafe = prev ?? initialState;
                            return {
                              ...prevSafe,
                              poCodes: selectedPo ? [selectedPo] : [],
                            };
                          });
                        }}
                        error={getErrorState("poCodes")}
                      >
                        {poList.map((obj) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            {obj.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                  </Box>
                </Gridm>
              </Gridm>
            </CustomTabPanel>
          );
        })}
      </Box> */}


      <Grid item xs={12} sm={12} md={12} lg={12}>
        <div className={classes.BtnArea}>
          <div className={classes.reqLbl}>
            <span>{translation.vendor_crete_form1_reuired_txt}</span>
          </div>
          <div className={classes.BtnGreenWrapper}>
            <Button onClick={handleSubmit}>
              <CheckCircleIcon></CheckCircleIcon>
              {translation.vendor_block_submit_btn}
            </Button>
          </div>
        </div>
      </Grid>

      <ValidationErrors
        open={openValidateErrDialog}
        setOpen={setOpenValidateErrDialog}
        errorList={formErrors}
      ></ValidationErrors>
    </div>
    
  );
}
